import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import {
  DropdownMenu,
  DropdownMenuButton,
  DropdownMenuItems,
  DropdownMenuItem
} from '@jetshop/ui/DropdownMenu';
import { ReactComponent as Check } from '../../../svg/Check.svg';
import { ReactComponent as Caret } from '../../../svg/Caret.svg';

const Wrapper = styled('div')`
  display: flex;
  align-items: baseline;
  cursor: pointer;

  &.dropdown {
    flex-direction: column;
    padding: 16px 0;

    p {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
    }

    [data-flight-dropdown] {
      width: 100%;
    }
    [data-flight-dropdown-button] {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      border-radius: 0;
    }
    [data-flight-dropdown-items] {
      top: 98%;
      width: 100%;
      padding: 10px 0;
      width: 100%;
      border: 1px solid #c0c0c0;
    }
    [data-flight-dropdown-item] {
      border: none;
      padding: 5px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      :hover {
        color: #000;
      }
    }
  }
`;

const CheckBox = styled('div')`
  border: 2px solid ${theme.colors.gold};
  width: 14px;
  height: 14px;
  margin-right: 10px;

  &.wrapped {
    background-color: #333;
    outline: 2px solid #fff;
    outline-offset: -4px;
    padding: 1px;
  }
`;

const Select = styled('select')`
  width: 100%;
  padding: 4px;
  border: 1px solid #dcdcdc;
  background-color: white;
  cursor: pointer;
`;

export const WrappedProduct = ({
  wrapped,
  setWrapped,
  values,
  setFieldValue,
  checkbox
}) => {
  return (
    <>
      {checkbox ? (
        <Wrapper
          onClick={() => {
            setFieldValue(
              'comments[Pakkes inn som gave]',
              !values.comments.wrapped ? 'Ja' : null
            );
            setWrapped(!wrapped);
          }}
        >
          <CheckBox className={wrapped ? 'wrapped' : ''} />
          <p>Ønsker du den pakket inn som gave?</p>
        </Wrapper>
      ) : (
        <Wrapper className="dropdown">
          <p>Ønsker du den pakket inn som gave?</p>
          <DropdownMenu>
            <DropdownMenuButton>
              {wrapped ? 'Ja, pakk inn som gave' : 'Nei'}
              <Caret />
            </DropdownMenuButton>
            <DropdownMenuItems>
              <DropdownMenuItem
                onSelect={({ setIsOpen }) => {
                  setFieldValue('comments[Pakkes inn som gave]', null);
                  setWrapped(false);
                  setIsOpen(false);
                }}
              >
                Nei
                {!wrapped && <Check />}
              </DropdownMenuItem>
              <DropdownMenuItem
                onSelect={({ setIsOpen }) => {
                  setFieldValue(
                    'comments[Pakkes inn som gave]',
                    !values.comments.wrapped ? 'Ja' : null
                  );
                  setWrapped(true);
                  setIsOpen(false);
                }}
              >
                Ja, pakk inn som gave
                {wrapped && <Check />}
              </DropdownMenuItem>
            </DropdownMenuItems>
          </DropdownMenu>
        </Wrapper>
      )}
    </>
  );
};
